module.exports = __webpack_public_path__ + "img/135.8.8762b45f.png";